export const getConfig = () => {
  const GAMESAPP_CLIENT_ID = process.env.NEXT_PUBLIC_GAMESAPP_CLIENT_ID;
  const SERVICE_URL = process.env.NEXT_PUBLIC_SERVICE_URL;
  const API_URL = process.env.NEXT_PUBLIC_AWS_API_URL;

  const allVarsPresent = GAMESAPP_CLIENT_ID && SERVICE_URL && API_URL;

  if (!allVarsPresent) {
    throw new Error(
      'GamesAppBridge cannot be initialized: missing one or more required environment variables (NEXT_PUBLIC_GTM_ID, NEXT_PUBLIC_GTM_AUTH, NEXT_PUBLIC_GTM_PREVIEW).',
    );
  }

  return {
    gamesAppClientId: GAMESAPP_CLIENT_ID,
    clientServiceUrl: SERVICE_URL,
    awsApiUrl: API_URL,
  };
};
